import { render, staticRenderFns } from "./ContentEditorDashboard.vue?vue&type=template&id=0588d842&scoped=true&"
import script from "./ContentEditorDashboard.vue?vue&type=script&lang=js&"
export * from "./ContentEditorDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ContentEditorDashboard.vue?vue&type=style&index=0&id=0588d842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588d842",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCard,VCardText,VCardTitle,VCol,VContainer,VHover,VIcon,VRow})
